import { Row, Col } from 'components-antd';

import { ListedWidget } from './ListedWidget';
import { UnderContractWidget } from './UnderContractWidget';
import { ClientWidget } from './ClientWidget';
import { ExpiringListingWidget } from './ExpiringListingWidget';
import { ClosingWidget } from './ClosingWidget';
import { ClosedWidget } from './ClosedWidget';

import styles from './styles.module.scss';
import classNames from 'classnames';

export const PulseDashboardWidgets = ({ teamStats }) => {
  return (
    <div className={classNames(styles.pulseWidgetsSliderContainer, styles.scrollable)}>
      <Row gutter={24} className={styles.cardsRow}>
        <Col lg={8} sm={24}>
          <div className={styles.cardContainer}>
            <ListedWidget teamStats={teamStats} />
          </div>
        </Col>
        <Col lg={8} sm={24}>
          <div className={styles.cardContainer}>
            <UnderContractWidget teamStats={teamStats} />
          </div>
        </Col>

        <Col lg={8} sm={24}>
          <div className={styles.cardContainer}>
            <ClosingWidget teamStats={teamStats} />
          </div>
        </Col>
      </Row>

      <Row gutter={24} className={classNames(styles.cardsRow, styles.spacingTop)}>
        <Col lg={8} sm={24}>
          <div className={styles.cardContainer}>
            <ExpiringListingWidget teamStats={teamStats} />
          </div>
        </Col>

        <Col lg={8} sm={24}>
          <div className={styles.cardContainer}>
            <ClosedWidget teamStats={teamStats} />
          </div>
        </Col>
        <Col lg={8} sm={24}>
          <div className={styles.cardContainer}>
            <ClientWidget teamStats={teamStats} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
